(() => {
    const DIALOG_ID = 'photo-guidelines-dialog';
    const LINK_CLASS = 'photo-guidelines-link';

    const dialog = document.getElementById(DIALOG_ID);
    if (!dialog) return;

    const open = () => (dialog.showModal ? dialog.showModal() : (dialog.open = true));
    const close = () => (dialog.close ? dialog.close() : (dialog.open = false));

    dialog.addEventListener('click', (event) => {
      // Bấm ra ngoài hộp thì đóng: <dialog> nhận cả click vào backdrop.
      if (event.target === dialog) close();
      if (event.target.closest('[data-photo-guidelines-close]')) close();
    });

    const buildLink = () => {
      const link = document.createElement('button');
      link.type = 'button';
      link.className = LINK_CLASS;
      link.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/><path d="M12 11v5" stroke-linecap="round"/><path d="M12 8h.01" stroke-linecap="round"/>' +
        '</svg><span>Photo guidelines</span>';
      link.addEventListener('click', open);
      return link;
    };

    const inject = () => {
      document.querySelectorAll('#cl_optionsapp .customily_option').forEach((option) => {
        if (!option.querySelector('.customily-file-input')) return;
        const label = option.querySelector('label');
        if (!label || label.querySelector('.' + LINK_CLASS)) return;
        label.classList.add('has-photo-guidelines');
        label.appendChild(buildLink());
      });
    };

    const root = document.getElementById('customily-options') || document.body;
    new MutationObserver(inject).observe(root, { childList: true, subtree: true });
    inject();
  })();
